<template>
    <div class="contract-page">
        <div class="page-title">签署合同设置</div>
        <div class="tabs">
            <div class="tab" :class="{active:current == 0}" @click="tabClicked(0)">
                <div class="name">签章设置</div>
                <div class="line" v-if="current == 0"></div>
            </div>
            <div class="tab" :class="{active:current == 1}" @click="tabClicked(1)">
                <div class="name">已设合同</div>
                <div class="line" v-if="current == 1"></div>
            </div>
            <div class="tab" :class="{active:current == 2}" @click="tabClicked(2)">
                <div class="name">已签合同</div>
                <div class="line" v-if="current == 2"></div>
            </div>
        </div>

        <set-signature v-if="current == 0" :info="info"></set-signature>

        <div v-if="current == 1">
            <contract-update v-if="isCreate" :id="id" :info="info" @cancel="cancelClicked" @save="save"></contract-update>
            <already-set v-else ref="lreadySet" @create="createClicked" @edit="edit" @del="del"></already-set>
        </div>

        <signed v-if="current == 2"></signed>
    </div>
</template>

<script>
import api from '@/repo/api';
import setSignature from './contract/setSignature';
import alreadySet from './contract/alreadySet';
import signed from './contract/signed';
import ContractUpdate from './contract/ContractUpdate';

export default {
    components: {
        setSignature,alreadySet,signed,ContractUpdate
    },
    data() {
        return {
            id:0,
            current:0,
            isCreate: false,
            info:{
                enterprise_seal_image_url: '', // 企业印章图片
                need_real_name_verified: 1, // 签名前是否需要身份实名认证 1 是 0 否
                enterprise_name: '', // 企业名称
                enterprise_address: '', // 企业地址
                enterprise_phone: '', // 企业电话
                legal_representative_name: '', // 法人姓名
            }
        }
    },
    mounted() {
      this.getInfo();  
    },
    methods: {
        // 切换tab
        tabClicked(index) {
            this.current = index;
            this.isCreate = false; 
        },
        // 创建合同
        createClicked(){
            this.isCreate = true;
        },
        // 取消
        cancelClicked(){
            this.isCreate = false; 
        },
        // 编辑
        edit(id){
            this.id = id;
            this.isCreate = true;  
        },
        // 删除
        del(id){
            this.$confirm({
                title: `提示`,
                content: '删除后无法恢复，确定删除该合同吗？',
                onOk: () => {
                    api.post('/ast-contract/delete-contract',{id}, (res) => {
                        if (res.code === 0) {
                            this.$message.success('删除成功');
                            this.$refs.lreadySet.getList();
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                },
            });
        },
        // 保存合同
        save(){
            this.id = 0;
            this.isCreate = false;
            this.$loading.hide();
            this.$message.success('保存成功');
        },
        // 获取信息
        getInfo(){
            api.get('/ast-contract/contract-info', (res) => {
                if (res.code === 0) {
                    this.info.enterprise_seal_image_url = res.data.enterprise_seal_image_url;
                    this.info.need_real_name_verified = res.data.need_real_name_verified;
                    this.info.enterprise_name = res.data.enterprise_name;
                    this.info.enterprise_address = res.data.enterprise_address;
                    this.info.enterprise_phone = res.data.enterprise_phone;
                    this.info.legal_representative_name = res.data.legal_representative_name;
                } else {
                    this.$message.error('获取信息失败!');
                }
            }); 
        },
    }
}
</script>

<style lang="less" scoped>
    .contract-page{
        cursor: default;
    }
    .page-title {
        font-size: 20px;
        color: #333;
        font-weight: bold;
        margin-bottom: 40px;
    }
    .tabs {
        display: flex;
        align-items: center;
        .tab{
            height: 34px;
            margin-right: 64px;
            position: relative;
            .name{
                color: #999999;
                font-size: 16px;
                line-height: 22px;
            }
           .line{
                width: 100%;
                height: 2px;
                background: #333;
                position: absolute;
                bottom: 0;
                left: 0;
           }
        }
        .active{
            .name{
                color: #333;
            }
        }
    }
</style>